import {
  API_STATES
} from '@/helpers'

const state = {
  modulesGetState    : API_STATES.NOT_REQUESTED,
  modulessGetError   : null,
  modulesUpdateState : API_STATES.NOT_REQUESTED,
  modulesUpdateError : null,
  modules            : {}
}

export default state
